import React from 'react'
import styles from './Navbar.module.css' // Import module-specific styles
import { Link } from 'react-router-dom'
import logo from '../../Assets/Logo.png' // Import asset image

const Navbar = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.navContainer}>
        {/* Logo with a link to the home page */}
        <Link to="/">
          <img src={logo} alt="Finsweet Logo" />
        </Link>
        <div className={styles.navRight}>
          {/* Navigation menu with links to each page */}
          <ul className={styles.navMenu}>
            <li>
              <Link to="/" className={styles.navMenuItem}>Home</Link>
            </li>
            <li>
              <Link to="/product" className={styles.navMenuItem}>Product</Link>
            </li>
            <li>
              <Link to="/pricing" className={styles.navMenuItem}>Pricing</Link>
            </li>
            <li>
              <Link to="/about" className={styles.navMenuItem}>About Us</Link>
            </li>
            <li>
              <Link to="/blog" className={styles.navMenuItem}>Blog</Link>
            </li>
            <li>
              <Link to="/contact" className={styles.navMenuItem}>Contact</Link>
            </li>
          </ul>
          {/* Button for free trial */}
          <Link to="/pricing">
            <button>Free Trial</button>
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
